import { ComponentIds, DraggableComponent } from '@inter-ikea-core/core';
import { PlannerEcsSystem } from './System';
export class DraggableWhenSelectedSystem extends PlannerEcsSystem {
    constructor(coreApi, productTypes) {
        super(coreApi, 'DraggableWhenSelectedSystem', ComponentIds.SELECTED_COMPONENT_ID);
        this.productTypes = productTypes;
    }
    onAdd(entity) {
        this.entitySelected(entity);
    }
    onUpdate() { }
    onRemove(entity) {
        this.entityUnselected(entity);
    }
    shouldBeDraggableWhenSelected(entity) {
        return this.coreApi.entities.isOneOfProductTypes(entity, this.productTypes);
    }
    isCurrentlyDragged(entity) {
        return entity.hasComponent(ComponentIds.IS_DRAGGED_COMPONENT_ID);
    }
    entitySelected(entity) {
        if (this.shouldBeDraggableWhenSelected(entity)) {
            entity.addComponent(new DraggableComponent());
        }
    }
    entityUnselected(entity) {
        if (this.shouldBeDraggableWhenSelected(entity) && !this.isCurrentlyDragged(entity)) {
            entity.removeComponent(ComponentIds.DRAGGABLE_COMPONENT_ID);
        }
    }
}
//# sourceMappingURL=DraggableWhenSelectedSystem.js.map